module.exports = __webpack_public_path__ + "img/02_Cladding and Battens Tile.f12826bd.png";